import axios, { AxiosRequestConfig } from 'axios';
import { Toast } from 'vant';
import vueCookies from 'vue-cookies';
import store from '@/store';

const https = axios.create({ baseURL: process.env.VUE_APP_BASE_URL });

// https.defaults.headers.common['token'] = (vueCookies as any).get('token');

https.interceptors.request.use((config: AxiosRequestConfig) => {
  const token = (vueCookies as any).get('token') || '';
  if (token) {
    config.headers = {
      ...config.headers,
      token,
    };
  }
  return config;
});

https.interceptors.response.use(
  (response) => {
    const { errMsg, errCode, data } = response.data || {};

    if (errCode === 200) return data;

    Toast(errMsg);

    if ([401, 444].includes(errCode)) {
      store.dispatch('user/ACTION_SIGN_OUT');
    }

    return Promise.reject(new Error(errMsg));
  },
  ({ message }) => {
    Toast({ message });
    return Promise.reject(message);
  }
);

export default https;
